<template>
  <div class="trainMain">
    <div class="nav_warp">
      <div class="top">
        <div class="icon" @click="showTip = true">
          <v-icon name="regular/arrow-alt-circle-left" scale="1.5"></v-icon>
        </div>
        添加训练计划
      </div>
      <div class="bottom">
        <div
          v-for="(item, index) in nav"
          :key="index"
          :class="index === idx ? 'active' :''"
          class="yioks_btn">{{item}}</div>
      </div>
    </div>
    <div class="content">
      <StepOne v-if="idx === 0"  @changeNav="changeNav" />
      <StepTwo v-if="idx === 1" @changeNav="changeNav" />
      <div v-show="idx === 2" class="scroll_wrap">
        <vue-scroll v-if="!loading" ref="scroll">
          <div class="evaluation">
            <el-form
            v-show="idx === 2"
            ref="evaluation"
            :model="evaluation"
            class="black_form">
              <div class="item_title">训练总结*</div>
              <el-form-item prop="summary" :rules="[{required: true, message: '请输入训练总结', trigger: 'blur'}]">
                <el-input
                  v-model.trim="evaluation.summary"
                  :rows="5"
                  :placeholder="$t('trainingPlanPlaceholder')"
                  type="textarea"></el-input>
              </el-form-item>
              <div class="item_title side">
                视频
                <div>
                  <span style="cursor: pointer" @click="addMedia">本地上传视频</span>
                  <span style="margin: 0 10px">/</span>
                  <span style="cursor: pointer" @click="associateMore">从视频库中选择</span>
                </div>
              </div>
              <div class="trainPlan">
                <div
                  v-for="(item,index) in videoToPlayerVos"
                  :key="index"
                  class="mediaDetail"
                  @click.stop="goDetail(item.uuid)">
                  <div class="img">
                    <img
                      class="playImg"
                      :src="playImg"
                      style="position: absolute;top: 30px;left: 65px;"
                      @click.stop="openVideoDialog(item.videoAddress,item.videoCoverAddress)">
                    <img
                      class="coverImg "
                      :src="item.videoCoverAddress || planImg"
                      alt=""
                      style="width: 170px;height:100px"
                      @error="item.videoCoverAddress === planImg" >
                  </div>
                  <div class="intro">
                    <p class="p_item">标题：{{item.videoTitle || '--'}}</p>
                    <p class="p_item">上传人：{{item.authorName}}</p>
                    <p >时长： {{filterTime(parseInt(item.videoDuration / 60))}}:{{ filterTime(item.videoDuration % 60)}}</p>
                  </div>
                </div>
              </div>
              <yioks-empty v-show="videoToPlayerVos.length === 0" :h="'150px'"></yioks-empty>
              <div class="item_title">
                球员出勤
<!--                <div>-->
<!--                  是否依据中国足协青训大纲“五环模型”进行球员评价 (建议每半年、每季度及每六周评价一次)-->
<!--                  <el-switch-->
<!--                    v-model="isEvalu"-->
<!--                    style="margin-left:10px"-->
<!--                    active-color="#4cd964"-->
<!--                    ></el-switch>-->
<!--                </div>-->
              </div>
              <div class="attendance_wrap">
                <div v-for="(item, index) in playerList" :key="index" class="item">
                  <img :src="person" alt="">
                  <div class="info">
                    <div>姓名：{{item.idName}}</div>
                    <div class="slider_wrap">
                      出勤率：
                      <div class="slider">
                        <el-slider v-model="item.attendance" :step="10" :show-tooltip="false"></el-slider>
                      </div>
                    </div>
                    <div class="attendanceNum">{{item.attendance}}%</div>
                  </div>
                </div>
              </div>
              <div class="item_title side">
                {{$t('evaluation')}}
                <div>
                  是否依据中国足协青训大纲“五环模型”进行球员评价 (建议每半年、每季度及每六周评价一次)
                  <el-switch
                      v-model="isEvalu"
                      style="margin-left:10px"
                      active-color="#4cd964"
                  ></el-switch>
                </div>
              </div>
              <div v-show="isEvalu">
                <div v-for="(item, index) in playerList" :key="index" class="player-box">
                  <div class="left-info-box">
                    <div class="head-img-box">
                      <img class="head-img" :src="person" alt="">
                      {{item.idName}}
                    </div>
                    <div class="select-box">
                      <div class="head-input-label">
                        <div class="head-input-label-text">{{$t('position')}}</div>
                        <el-select
                          v-model.trim="item.position"
                          size="small"
                          style="padding:0;margin-left:0px"
                          :placeholder="$t('positionPlaceholder')">
                          <el-option
                            v-for="(item, index) in playerOption"
                            :key="index"
                            :label="item.playerPositionName"
                            :value="item.playerPositionName"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                  <div class="right-info-box">
                   <div class="row">
                     <div class="label-wrapper">
                       {{$t('allEvaluation')}}：
                     </div>
                     <div class="input-wrapper">
                       <el-input
                         v-model.trim="item.generalEvalComments"
                         class="input-style"
                         type="textarea"
                         :rows="3"
                         maxlength="100"
                         show-word-limit
                         :placeholder="$t('allEvaluation')"></el-input>
                     </div>
                   </div>
                    <div class="row">
                      <div class="label-wrapper">
                        技术评价：
                      </div>
                      <div class="input-wrapper">
                        <el-input
                          v-model.trim="item.technicalScore"
                          maxlength="50"
                          show-word-limit
                          placeholder="技术能力"
                        ></el-input>
                      </div>
                    </div>
                    <div class="row">
                      <div class="label-wrapper">
                        战术评价：
                      </div>
                      <div class="input-wrapper">
                        <el-input
                          v-model.trim="item.tacticalScore"
                          maxlength="50"
                          show-word-limit
                          placeholder="战术能力"
                        ></el-input>
                      </div>
                    </div>
                    <div class="row">
                      <div class="label-wrapper">
                        体能评价：
                      </div>
                      <div class="input-wrapper">
                        <el-input
                          v-model.trim="item.physicalScore"
                          maxlength="50"
                          show-word-limit
                          placeholder="体能"
                        ></el-input>
                      </div>
                    </div>
                    <div class="row">
                      <div class="label-wrapper">
                        心智评价：
                      </div>
                      <div class="input-wrapper">
                        <el-input
                          v-model.trim="item.psychologicalScore"
                          maxlength="50"
                          show-word-limit
                          placeholder="心智能力"
                        ></el-input>
                      </div>
                    </div>
                    <div class="row">
                      <div class="label-wrapper">
                        社交评价：
                      </div>
                      <div class="input-wrapper">
                        <el-input
                          v-model.trim="item.overallScore"
                          maxlength="50"
                          show-word-limit
                          placeholder="社交能力"
                        ></el-input>
                      </div>
                    </div>
                    <div class="row">
                      <div class="label-wrapper">
                        {{$t('advice')}}：
                      </div>
                      <div class="input-wrapper">
                        <el-input
                          v-model.trim="item.learningObjectives"
                          type="textarea"
                          :raws="3"
                          maxlength="100"
                          show-word-limit
                          :placeholder="$t('advicePlaceholder')"
                          style="padding:0"></el-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-form>
          </div>
        </vue-scroll>
        <yioks-loading v-if="loading"></yioks-loading>
      </div>
    </div>
    <div  v-show="idx === 2" class="btn_wrap">
      <el-button
        type="primary"
        style="margin-right: 20px"
        @click="saveTip(1,1)">暂时保存</el-button>
      <el-button
        type="primary"
        style="margin-right: 20px"
        @click="saveTip(2,1)">上一步</el-button>
      <el-button
        v-show="idx === 2"
        type="primary"
        style="margin-right: 20px"
        @click="saveTip(3,0)">提交</el-button>
      <el-button type="danger" @click="saveTip(0)">取消</el-button>
    </div>
    <yioks-tip-loading :showTip="showTip" :tipMsg="tipMsg[btnStatus]" @callback="goBack"></yioks-tip-loading>
    <template v-if="showVideo">
      <el-dialog
        :visible.sync="showVideo"
        width="800px"
        class="linkAllDialog"
        :close-on-click-modal="false"
        top="12vh">
        <div style="text-align: center;background-color: black;width: 760px" >
          <video
            ref="video"
            controls
            width="760"
            autoplay
            disablePictureInPicture
            :poster="poster"
            controlsList = "nodownload noremoteplayback"
            height="400">
            <source :src="videoSrc" type="video/mp4">
          </video>
        </div>
      </el-dialog>
    </template>
    <template v-if="showDialog">
      <associateMore
        :objectUuid="trainUuid"
        :type="link.type"
        :obj="propObj"
        :title="link.title"
        :organUuid="orgInfo.organUuid"
        :youthUuid="orgInfo.youthUuid"
        :showDialog.sync="showDialog"
        mediaType="event"
        @hideDialog="hideDialog"></associateMore>
    </template>
    <template v-if="showMediaUpload">
      <uploadMedia
        :showTip.sync="showMediaUpload"
        :orgInfo="orgInfo"
        :uuid="propUuid"
        type="event"
        @hideUploadDialog ="hideUploadDialog"></uploadMedia>
    </template>
  </div>
</template>

<script>

import 'vue-awesome/icons/regular/arrow-alt-circle-left'
import person from '@/assets/images/common/person.jpg'
// import common from '@/api/common'
import player from '@/api/player'
import playImg from '@/assets/images/common/playImg.png'
import planImg from '@/assets/images/common/plan_default.png'

import training from '@/api/training'
import media from '@/api/media'
export default {
  components: {
    'StepOne': () => import('./StepOne'),
    'StepTwo': () => import('./StepTwo'),
    'associateMore': () => import('@/components/associatedDialog/associatedMore'),
    'uploadMedia': () => import('@/views/media/uploadMedia')
  },
  filters: {
    filterTime (val) {
      return `${parseInt(val / 60)} 小时 ${val % 60} 分`
    }
  },
  data () {
    return {
      playImg,
      planImg,
      planStatus: '',
      nav: ['第一步：编写训练计划', '第二步：确认计划实施', '第三步：训练评价'],
      idx: this.$route.query.idx ? Number(this.$route.query.idx) : 0,
      showTip: false,
      evaluation: {
        summary: ''
      },
      playerOption: [],
      position: '',
      person,
      isEvalu: false,
      trainUuid: this.$route.query.uuid,
      trainingStatus: this.$route.query.trainingStatus,
      squadUuid: this.$route.query.squadUuid,
      aheadTrainingStartTime: this.$route.query.aheadTrainingStartTime, // 传参提前训练计划预案的开始时间
      aheadTrainingEndTime: this.$route.query.aheadTrainingEndTime, // 传参提前训练计划预案的结束时间
      aheadTrainingUuid: this.$route.query.aheadTrainingUuid, // 传参提前训练计划预案的uuid
      playerList: [],
      tipMsg: ['确定放弃修改并返回吗?', '确定暂时保存并返回吗?', '确定暂时保存并返回上一步吗?', '确定保存并提交吗?'],
      btnStatus: 0, // 0: 返回列表不保存 1:返回列表保存  2：返回上一步保存
      saveBtn: false,
      loading: false,
      videoToPlayerVos: [],
      showMediaUpload: false,
      orgInfo: {
        organUuid: '',
        organShortName: '',
        youthUuid: '',
        youthShortName: ''
      },
      propUuid: '',
      showDialog: false,
      link: {
        title: '',
        type: ''
      },
      propObj: {},
      videoSrc: '',
      poster: '',
      showVideo: false
    }
  },
  computed: {
    // 暂时不需要
    // planeType() {
    //   const { planeType } = this.$route.query; // byDoc 文件创建计划；byTrain 教案创建计划
    //   return planeType || "byTrain";
    // },
  },
  watch: {
    isEvalu (val) {
      if (val && !this.playerOption.length) {
        this.getCommonData()
      }
    },
    showTip (val) {
      if (!val) {
        this.btnStatus = 0
      }
    }
  },
  created () {
    // 训练计划状态判断，防止用户通过改动 url参数进入页面
    // INITIATED 不会进入当前页
    // if (this.trainingStatus === 'INITIATED') {
    //   this.$message.error('信息错误')
    //   this.$router.push('/home/index')
    // }
    if (this.idx === 2) {
      this.getCommentInfo()
      this.getVideoList()
    }
  },
  methods: {
    filterTime (val) {
      if (val === 0) {
        return '00'
      }
      if (String(val).length < 2) {
        return '0' + String(val)
      } else {
        return val
      }
    },
    saveTip (index, status) {
      if (index === 3) {
        this.$refs.evaluation.validate(vali => {
          if (vali) {
            this.showTip = true
            this.btnStatus = index
            this.planStatus = status
          } else {
            this.$refs['scroll'].scrollTo({ y: 0 })
            this.$message.error('请填写训练总结！')
          }
        })
      } else {
        this.showTip = true
        this.btnStatus = index
        this.planStatus = status
      }
    },
    getCommentInfo () {
      this.loading = true
      training.commentInfo(this.trainUuid).then(res => {
        this.loading = false
        if (res.code) {
          this.$message.error('信息错误')
          this.$router.push('/home/index')
        } else {
          res.trainingInfo && res.trainingInfo.organUuid && this.$set(this.orgInfo, 'organUuid', res.trainingInfo.organUuid)
          res.trainingInfo && res.trainingInfo.organShortName && this.$set(this.orgInfo, 'organShortName', res.trainingInfo.organShortName)
          res.trainingInfo && res.trainingInfo.youthUuid && this.$set(this.orgInfo, 'youthUuid', res.trainingInfo.youthUuid)
          res.trainingInfo && res.trainingInfo.youthShortName && this.$set(this.orgInfo, 'youthShortName', res.trainingInfo.youthShortName)
          this.evaluation.summary = res.trainingSummary
          this.playerList = res.playerList
          this.isEvalu = !!res.commentStatus
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },
    getVideoList () {
      media.videoListToObjectList({
        objectUuid: this.trainUuid
      }).then(res => {
        this.videoToPlayerVos = res
      })
    },
    openVideoDialog (src, poster) {
      this.videoSrc = src
      this.poster = poster || ''
      this.showVideo = true
    },
    goBack (isShow) {
      if (isShow) {
        // 暂时保存，上一步、保存都保存数据
        if (this.btnStatus) {
          this.savePlain()
        } else {
          this.$router.go(-1)
          // this.$router.replace({
          //   path: '/training/list',
          //   query: {
          //     idx: 1, // 这里写死的 1，因为只能跳转到 1
          //     uuid: this.squadUuid
          //   }
          // })
        }
      } else {
        this.showTip = false
      }
    },
    nextStep () {
      this.idx = this.idx + 1
    },
    previousStep () {
      this.changeNav({ jump: 1, ...this.$route.query })
    },
    savePlain () {
      let data = {
        'isTempSave': this.planStatus,
        'commentStatus': this.isEvalu ? 1 : 0,
        'playerFrom': this.playerList.map(item => {
          return {
            'trainingUuid': this.trainUuid,
            'squadUuid': this.squadUuid,
            'attendance': item.attendance,
            'playerUuid': item.playerUuid,
            'position': item.position,
            'generalEvalComments': item.generalEvalComments,
            'learningObjectives': item.learningObjectives,
            'physicalScore': item.physicalScore,
            'psychologicalScore': item.psychologicalScore,
            'tacticalScore': item.tacticalScore,
            'overallScore': item.overallScore,
            'technicalScore': item.technicalScore
          }
        }),
        'trainingComment': this.evaluation.summary,
        'trainingUuid': this.trainUuid
      }
      training.savePlan(data).then(res => {
        if (this.btnStatus === 1) { // 暂时保存
          this.$router.replace({
            path: '/training/list',
            query: {
              idx: 1, // 没确定保存，状态肯定是待完善，所以 1
              // uuid: this.squadUuid // 不清楚为什么球队uuid要写成uuid
              squadUuid: this.squadUuid,
              aheadTrainingStartTime: this.aheadTrainingStartTime,
              aheadTrainingEndTime: this.aheadTrainingEndTime,
              aheadTrainingUuid: this.aheadTrainingUuid,
            }
          })
        } else if (this.btnStatus === 2) { // 上一步
          this.showTip = false
          this.$router.replace({
            path: this.$route.path,
            query: {
              ...this.$route.query,
              idx: 1
            }
          })
          this.idx = 1
        } else {  // 提交
          this.$router.replace({
            path: '/training/list',
            query: {
              // idx: 2, // 确认保存，到第三步；因为胡总要求，只有一个页面，故此先不传
              // uuid: this.squadUuid// 不清楚为什么球队uuid要写成uuid
              squadUuid: this.squadUuid,
              aheadTrainingStartTime: this.aheadTrainingStartTime,
              aheadTrainingEndTime: this.aheadTrainingEndTime,
              aheadTrainingUuid: this.aheadTrainingUuid,
            }
          })
        }
      })
    },
    getCommonData () {
      player.allPositionList().then(res => {
        this.playerOption = res
      })
    },
    changeNav (data) {
      this.trainUuid = data.uuid
      if (data.jump === 1 || data.jump === 2) {
        this.$router.replace({
          path: this.$route.path,
          query: {
            idx: data.jump,
            trainingStatus: data.trainingStatus,
            squadUuid: data.squadUuid,
            uuid: data.uuid,
            // planeType: data.planeType || this.planeType,// 暂时不需要
            aheadTrainingStartTime: data.aheadTrainingStartTime, // 传参提前训练计划预案的开始时间
            aheadTrainingEndTime: data.aheadTrainingEndTime, // 传参提前训练计划预案的结束时间
            aheadTrainingUuid: data.aheadTrainingUuid, // 传参提前训练计划预案的uuid
          }
        })
        if (data.jump === 2) {
          this.getCommentInfo()
          this.getVideoList()
        }
      }
      if (data.jump === 0) {
        this.$router.replace({
          path: this.$route.path,
          query: {
            uuid: data.uuid,
             // planeType: data.planeType || this.planeType,// 暂时不需要
            aheadTrainingStartTime: data.aheadTrainingStartTime, // 传参提前训练计划预案的开始时间
            aheadTrainingEndTime: data.aheadTrainingEndTime, // 传参提前训练计划预案的结束时间
            aheadTrainingUuid: data.aheadTrainingUuid, // 传参提前训练计划预案的uuid
          }
        })
      }
      this.idx = data.jump
    },
    addMedia () {
      this.propUuid = this.trainUuid
      this.showMediaUpload = true
    },
    associateMore () {
      this.$set(this.link, 'type', 'media')
      this.$set(this.link, 'title', '从视频库中选择')
      this.showDialog = true
    },
    hideUploadDialog (val) {
      this.showMediaUpload = val
      this.getVideoList()
    },
    hideDialog (val) {
      this.showDialog = val
      this.getVideoList()
    },
    goDetail (uuid) {
      this.$router.push({
        path: '/media/detail',
        query: {
          uuid
        }
      })
    }
  }
}
</script>
<style lang="stylus">
.trainMain
  .el-dialog__header
    display flex
</style>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .trainMain
    display flex
    height 710px
    width 890px
    justify-content space-between
    flex-direction column
    .nav_warp
      color #DDD
      background $black_color
      font-size 18px
      width 100%
      /*margin .5rem 0 .3rem*/
      box-sizing border-box
      user-select none
      padding 20px 20px 10px
      .top
        display flex
        align-items center
        .icon
          cursor pointer
          margin-right 20px
      .bottom
        border-top 1px solid #FFF
        padding-top 10px
        margin 10px 0 0
        display flex
        justify-content space-around
        .yioks_btn
          background none
          cursor default
          &.active
            background $green_color
            color #FFF
    .content
      color #FFF
      font-size 18px
      width 100%
      height 600px
      box-sizing border-box
      padding 20px 0
      .scroll_wrap
        height 510px
        padding 10px 0
        overflow hidden
        background-color $black_color
        .black_form
          margin 0 20px 40px
      .evaluation
        font-size 16px
        .item_title
          padding  20px 0
          margin-bottom 20px
          border-bottom 1px solid #FFF
          &.side
            display flex
            justify-content space-between
        .attendance_wrap
          display flex
          flex-wrap wrap
          .item
            display flex
            align-items center
            border 1px solid #FFF
            padding 10px
            margin 0 10px 10px 0
            img
              width 50px
              height 50px
              border-radius 50px
              margin-right 10px
            .slider_wrap
              min-width 130px
              display flex
              align-items center
              margin-top 5px
              .slider
                flex 1
            .attendanceNum
              text-align center
              padding-left 50px
        .trainPlan
          display flex
          justify-content space-between
          flex-wrap wrap
          .planDetail
            border  1px solid white
            width 100%
            .row
              min-height 49px
              display flex
              align-items center
              border-bottom 1px solid white
              &:last-child
                border-bottom   none
              .col
                width:  50%
                padding 0 10px 0 20px
                height 100%
                line-height 49px
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                &:first-child
                  border-right  1px solid white
            .rowLine
              padding: 10px  10px  10px 20px
          .mediaDetail
            background-color rgba(0,0,0,0.7)
            border  1px solid white
            padding  20px
            width 400px
            display flex
            align-items center
            cursor pointer
            margin-bottom 20px
            .p_item
              margin-bottom 10px
          .img
            width 170px
            height 100px
            position relative
            .coverImg
              width 100%
              height 100%
          .intro
            padding-left 10px
            width: calc(100% - 170px);
            height 100px
            display flex
            flex-direction column
            justify-content space-between
      .player_box
        border 1px solid #FFF
        border-right 0
        margin-bottom 20px
        margin-right 12px
      .row
        display flex
        align-items center
        justify-content center
        &:last-child
          border-bottom none
      .column
        text-align center
        img
          width 80px
          height 80px
          border-radius 80px
          margin 0 10px 20px
      .player_info
        flex 1
        border-left 1px solid #FFF
        .row
          div
            flex 1
            padding 10px
            text-align center
      .border
        border-right 1px solid #FFF
        border-bottom 1px solid #FFF
      .border_right
        border-right 1px solid #FFF
    .btn_wrap
      display flex
      justify-content center
      /*margin-top 45px*/
  .player-box
    border 1px solid #FFF
    margin-bottom 20px
    margin-right 12px
    display flex
    .left-info-box
      width 160px
      display flex
      flex-direction column
      align-items center
      justify-content center
      .head-img-box
        width 100%
        display flex
        flex-direction column
        justify-content center
        align-items center
        .head-img
          width 80px
          height 80px
          border-radius 80px
          margin 0 10px 20px
      .select-box
        margin-top 20px
        padding 5px 10px
        .head-input-label
          display flex
          flex-direction column
          .head-input-label-text
            display flex
            align-items center
            justify-content center
    .right-info-box
      border-left 1px solid #FFF
      width 100%
      .row
        width 100%
        border-bottom 1px solid #FFFFFF
        padding 15px 10px
        display flex
        .label-wrapper
          width 95px
          text-align right
        .input-wrapper
          padding 0 10px
          display flex
          width: 100%
          .input-style
            width 100%
</style>
